import DOMPurify from 'dompurify';

export function transXssTitle(text) {
  let copy = text;
  copy = copy.replace(/(&lt;)/gi, '<');
  copy = copy.replace(/(&gt;)/gi, '>');
  copy = copy.replace(/(&#40;)/gi, '(');
  copy = copy.replace(/(&#41;)/gi, ')');
  copy = copy.replace(/(&#x2F;)/gi, '/');
  return copy;
}
export function transXssText(text) {
  let copy = text;
  copy = copy.replace(/(&lt;)/gi, '<');
  copy = copy.replace(/(&gt;)/gi, '>');
  copy = copy.replace(/(&#40;)/gi, '(');
  copy = copy.replace(/(&#41;)/gi, ')');
  copy = copy.replace(/(&#x2F;)/gi, '/');
  return DOMPurify.sanitize(copy);
}
